module.exports = __webpack_public_path__ + "img/RadectLogo.b0089b45.png";